import React, { useEffect, useCallback, useState } from "react";
import './Hotkeys.css';
import { getHotkeyStore } from '../../store/hotkeyStore';

function Hotkeys({ displayModal, sendMessage, actions, setActions, characterId }) {
    const keys = ['F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9'];
    const [actionId, setActionId] = useState(0);

    // Ensure we're using the persisted actions from the store
    useEffect(() => {
        // If we have a character ID but no actions loaded yet, try to get them from the store
        if (characterId && (!actions || actions.length === 0)) {
            const store = getHotkeyStore(characterId);
            if (store) {
                const storedActions = store.getState().actions;
                if (storedActions && storedActions.length > 0) {
                    setActions(storedActions);
                }
            }
        }
    }, [characterId, actions, setActions]);

    const handleKeyPress = useCallback((event) => {
        const { code, shiftKey } = event;
        
        // Handle Shift + Left/Right arrow keys for hotkey set switching
        // Allow this even when chat input has focus since left/right aren't used for chat history
        if (shiftKey && (code === 'ArrowLeft' || code === 'ArrowRight')) {
            event.preventDefault();
            event.stopPropagation();
            
            if (code === 'ArrowLeft') {
                // Cycle backwards through hotkey sets
                const newActionId = actionId === 0 ? 3 : actionId - 1;
                switchHotkey(newActionId);
            } else if (code === 'ArrowRight') {
                // Cycle forwards through hotkey sets
                const newActionId = actionId === 3 ? 0 : actionId + 1;
                switchHotkey(newActionId);
            }
            return;
        }
        
        // Handle function key presses
        if (!actions || actions.length === 0 || !actions[actionId]) return;

        const action = actions[actionId].find(action => action.key === code);
        if (action && action.cmd) {
            fire(action.cmd);
        }

        if (keys.includes(code)) {
            event.preventDefault();
        }

    }, [actions, actionId]);

    const handleKeyRelease = useCallback((event) => {
        // Empty function but kept for potential future use
    }, []);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyPress);
        window.addEventListener('keyup', handleKeyRelease);

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
            window.removeEventListener('keyup', handleKeyRelease);
        };
    }, [handleKeyPress, handleKeyRelease]);

    const fire = (hotkey) => {
        if (hotkey === '/hotkey') {
            openHotkeyEditor();
            return;
        }
        if (hotkey === "/help") {
            displayModal('help');
            return;
        }
        if (hotkey && hotkey.length > 0) {
            sendMessage('600' + hotkey);
        }
    }

    const openHotkeyEditor = () => {
        displayModal({ type: 'hotkey', initialSet: actionId });
    };

    const switchHotkey = (index) => {
        if (!actions || actions.length <= index || index < 0) {
            return;
        }
        setActionId(index);
    }

    // If no actions are available yet, show a loading state or empty buttons
    if (!actions || actions.length === 0) {
        return (
            <>
                <div className="hotkeys">
                    {Array(9).fill(0).map((_, i) => (
                        <button
                            key={i}
                            className="hotkey-button"
                            disabled
                            onContextMenuCapture={(e) => {
                                e.preventDefault();
                                openHotkeyEditor();
                            }}
                        >
                            Loading...
                        </button>
                    ))}
                </div>
                <div className="selector">
                    <button className="selector-button selector-icon" onClick={() => displayModal('help')} title="Help">
                        <span className="material-symbols-outlined">help</span>
                    </button>
                    <div className="selector-numbers">
                        <button className="selector-button selector-selected">1</button>
                        <button className="selector-button">2</button>
                        <button className="selector-button">3</button>
                        <button className="selector-button">4</button>
                    </div>
                    <button className="selector-button selector-icon" onClick={openHotkeyEditor} title="Edit Hotkeys">
                        <span className="material-symbols-outlined">settings</span>
                    </button>
                </div>
            </>
        );
    }

    return (
        <>
            <div className="hotkeys">
                {keys.map((key) => {
                    const action = actions[actionId]?.find(action => action.key === key);
                    return (
                        <button
                            key={key}
                            className="hotkey-button"
                            onContextMenuCapture={(e) => {
                                e.preventDefault();
                                openHotkeyEditor();
                            }}
                            onClick={() => action && action.cmd && fire(action.cmd)}
                            // disabled={!action || !action.name || !action.cmd}
                        >
                            {action ? action.name : ''}
                        </button>
                    );
                })}
            </div>
            <div className="selector">
                <button className="selector-button selector-icon" onClick={() => displayModal('help')} title="Help">
                    <span className="material-symbols-outlined">help</span>
                </button>
                <div className="selector-numbers">
                    <button className={"selector-button" + (actionId === 0 ? ' selector-selected' : '')} onClick={() => switchHotkey(0)}>1</button>
                    <button className={"selector-button" + (actionId === 1 ? ' selector-selected' : '')} onClick={() => switchHotkey(1)}>2</button>
                    <button className={"selector-button" + (actionId === 2 ? ' selector-selected' : '')} onClick={() => switchHotkey(2)}>3</button>
                    <button className={"selector-button" + (actionId === 3 ? ' selector-selected' : '')} onClick={() => switchHotkey(3)}>4</button>
                </div>
                <button className="selector-button selector-icon" onClick={openHotkeyEditor} title="Edit Hotkeys">
                    <span className="material-symbols-outlined">settings</span>
                </button>
            </div>
        </>
    );
}

export default Hotkeys;
